import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Quote } from 'lucide-react';

export const Testimonials = ({ t }) => {
  const testimonials = [
    {
      text: t.testimonial1,
      author: t.testimonial1Author,
      location: t.testimonial1Location
    },
    {
      text: t.testimonial2,
      author: t.testimonial2Author,
      location: t.testimonial2Location
    },
    {
      text: t.testimonial3,
      author: t.testimonial3Author,
      location: t.testimonial3Location
    }
  ];

  return (
    <section className="py-20 bg-brand-navy relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold font-serif text-white mb-4">
            {t.testimonialsTitle}
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="bg-white/95 backdrop-blur-sm border-none shadow-xl hover:shadow-2xl transform transition-all duration-300 hover:-translate-y-2"
            >
              <CardContent className="p-6">
                <div className="flex justify-center mb-4">
                  <div className="p-3 bg-brand-pink rounded-full">
                    <Quote className="h-6 w-6 text-white" />
                  </div>
                </div>
                <p className="text-gray-700 text-center mb-6 italic leading-relaxed">
                  "{testimonial.text}"
                </p>
                <div className="text-center">
                  <p className="font-bold font-serif text-brand-navy">{testimonial.author}</p>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      {/* ── Floating pill: Delivery Locations ────────────── */}
      <Link
        to="/raipur-delivery-areas"
        className="pill-float-3 inline-flex items-center gap-2 bg-white text-brand-navy text-sm font-bold px-5 py-2.5 rounded-full shadow-xl border-2 border-brand-pink/30 cursor-pointer no-underline transition-all duration-200"
      >
        <span>📍</span> Delivery Locations <span className="ml-1 text-brand-pink">→</span>
      </Link>

    </section>
  );
};
